import React, { Suspense, useEffect, useReducer } from 'react';
import './App.css';
import axios from 'axios';
import { cartReducer } from './reducers/cartReducer';
// import Products from './components/Products';
import Cart from './components/Cart';
const Products = React.lazy(()=> import("./components/Products"))

function App() {
  const [state, dispatch] = useReducer(cartReducer, {
    products:[],
    cart:[]
  })

  const fetchproducts = async ()=>{
    const {data}=await axios.get('https://dummyjson.com/products')
    dispatch({
      type:"addproducts",
      payload:data.products
    })
  }
  useEffect(()=>{
    fetchproducts()
  },[])


  return (
    <div className="App">
      <div style={{display:'flex'}}>
        <Suspense fallback={
        <div>
          Loading...
        </div>} >
          <Products state={state} dispatch={dispatch} />
        </Suspense>
        <Cart state={state} dispatch={dispatch} />
      </div>
    </div>
  );
}

export default App;
